'use client';

import type { FC, ReactNode } from 'react';
import { useSteamPriceAllowed } from '../../../components/ItemPrice';

export const WikiPriceGate: FC<{ children: ReactNode }> = ({ children }) => (useSteamPriceAllowed() ? children : null);
